export const COLOR_PALETTE = [
  // Row 1: Blues
  "#C8D9E9",
  "#92B2D3",
  "#5B8CBD",
  "#3A6692",
  "#24405B",
  "#BBE1F6",
  "#78C3ED",
  "#34A5E5",
  "#177CB5",
  "#0F4D71",
  // Row 2: Teals & Greens
  "#B2FFEA",
  "#66FFD5",
  "#1AFFC1",
  "#00CC94",
  "#00805D",
  "#C2F0C9",
  "#85E094",
  "#47D15E",
  "#29A33D",
  "#196626",
  // Row 3: Yellows & Golds
  "#EFE9C3",
  "#DED387",
  "#CEBD4B",
  "#A0922C",
  "#645B1B",
  "#F9D0B8",
  "#F3A172",
  "#ED722B",
  "#BC4E10",
  "#76310A",
  // Row 4: Corals & Magentas
  "#F7BAC2",
  "#F07585",
  "#E83047",
  "#B81429",
  "#730D1A",
  "#EDC4DC",
  "#DC89B8",
  "#CA4E95",
  "#9D2F6E",
  "#621D45",
  // Row 5: Neutrals & Indigos
  "#D9D9D9",
  "#B2B2B2",
  "#8C8C8C",
  "#666666",
  "#404040",
  "#C9C2F0",
  "#9485E0",
  "#5E47D1",
  "#3D29A3",
  "#261966",
] as const
